// extracted by css-extract-rspack-plugin
module.exports =  {"trending_wrapper":"J6IJJ","sliderHeading":"JaDcY","trending_wrapper_main":"Fds1F","sliderItem":"nutrq","sliderItemLink":"mE3TG","sliderItemHeading":"luC8J"};